import React from "react";
import TimeSheetReview from "../../components/TimeSheetReview";
import VStack from "../../ui_atoms/VStack";
import { WorkingTimeDurationBreakdownItemType } from "../../__generated__/graphql";
import { ScrollView } from "react-native";
import type { Meta, StoryObj } from "@storybook/react";

const ComponentStory = () => {
    return (
        <ScrollView style={{ flex: 1, width: "100%" }}>
            <VStack h="2/3">
                <TimeSheetReview
                    hoursBreakdown={[
                        {
                            hourRate: 100,
                            type: WorkingTimeDurationBreakdownItemType.Day,
                            totalDurationMinutes: 60,
                        },
                        {
                            hourRate: 150,
                            type: WorkingTimeDurationBreakdownItemType.Overtime,
                            totalDurationMinutes: 60,
                        },
                        {
                            hourRate: 100,
                            type: WorkingTimeDurationBreakdownItemType.Accident,
                            totalDurationMinutes: 60,
                        },
                    ]}
                />
            </VStack>
        </ScrollView>
    );
};

const meta = {
    title: "Views/Timesheet review",
    component: ComponentStory,
    argTypes: {},
    decorators: [
        (StoryFn) => (
            <ScrollView>
                <StoryFn />
            </ScrollView>
        ),
    ],
} satisfies Meta<typeof ComponentStory>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
